import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AdminApp } from "./AdminApp";
import { TelegramOnly } from "./components/TelegramOnly";
import { isTelegramMiniApp } from "./lib/telegramGate";
import "./styles/global.css";

/** admin.* subdomain or /admin → admin console; otherwise public TMA */
function isAdminHost(): boolean {
  const h = window.location.hostname.toLowerCase();
  if (h === "admin.localhost" || h.startsWith("admin.")) return true;
  if (window.location.pathname.startsWith("/admin")) return true;
  return false;
}

function Root() {
  if (isAdminHost()) return <AdminApp />;
  if (!isTelegramMiniApp()) return <TelegramOnly />;
  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
